/**
 * Zone.js performance optimizations
 * 
 * Disable unnecessary Zone.js patches to improve performance in PRODUCTION.
 * These flags must be set before importing zone.js in polyfills.ts
 * 
 * Angular 18: Conditional logic to NOT apply optimizations during tests
 */

// Check if running in Jest test environment
const isTestEnvironment = typeof (self as any).jest !== 'undefined';

if (!isTestEnvironment) {
  // Production only: Disable patching of requestAnimationFrame for better performance
  // Most apps don't need Zone to track requestAnimationFrame
  (window as any).__Zone_disable_requestAnimationFrame = true;

  // Production only: Disable patching of specific events that don't need change detection
  // This significantly improves scroll and mouse performance
  (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove'];

  // Uncomment if you experience issues with event handlers
  // (window as any).__Zone_disable_on_property = true;
}

// For tests: Allow full zone.js patching for proper change detection and async handling
